import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconEdgeRight24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconEdgeRight24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m4 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m9.25 2a.75.75 0 0 0-1.5 0v10a.75.75 0 0 0 1.5 0zM13 20a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3-15a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1.32 15a1 1 0 1 1-2 0 1 1 0 0 1 2 0M9 20a1 1 0 1 1-2 0 1 1 0 0 1 2 0M4 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconEdgeRight24);
